import { render, staticRenderFns } from "./addRecharge.vue?vue&type=template&id=2dd647fe&scoped=true&"
import script from "./addRecharge.vue?vue&type=script&lang=js&"
export * from "./addRecharge.vue?vue&type=script&lang=js&"
import style0 from "./addRecharge.vue?vue&type=style&index=0&id=2dd647fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd647fe",
  null
  
)

export default component.exports